module.exports = __webpack_public_path__ + "img/future3.9ec37afe.png";